import { useEffect, useRef } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

const BOOKING_ORIGIN = "https://booknow.hostechsolutions.com";

function BookingSearch() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${BOOKING_ORIGIN}/api/embed/tafaria/search.js`;
    script.async = true;
    document.querySelector("[data-booking-search='tafaria']")?.after(script);

    return () => script.remove();
  }, []);

  return <div data-booking-search="tafaria" />;
}

function BookingEngine() {
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.origin !== BOOKING_ORIGIN ||
        event.source !== iframeRef.current?.contentWindow ||
        event.data?.type !== "eres-booking-height" ||
        !Number.isFinite(event.data.height) ||
        event.data.height <= 0
      ) {
        return;
      }

      iframeRef.current.style.height = `${event.data.height}px`;
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      id="eres-booking-tafaria"
      src={`${BOOKING_ORIGIN}/s/tafaria?src=embed`}
      title="Book online at Tafaria"
      className="block w-full border-0"
      style={{ minHeight: 900 }}
    />
  );
}

export default function Stay() {
  return (
    <div className="min-h-screen bg-white text-[#1E2A4A]">
      <Nav />
      <main className="pt-[70px]">
        <section className="relative overflow-hidden bg-[#F5F8FC] px-6 py-12 lg:px-10 lg:py-16">
          <div className="hero-grid absolute inset-0 opacity-60" aria-hidden="true" />
          <div className="relative mx-auto max-w-7xl">
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-[#3AB0E1]">
              Tafaria
            </p>
            <h1 className="mt-3 font-display text-5xl font-bold tracking-tight text-[#263562] sm:text-6xl">
              Stay
            </h1>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-[#5A6B85] sm:text-lg">
              Find your dates and book your next stay.
            </p>
            <div className="mt-8 rounded-2xl border border-[#263562]/10 bg-white p-5 shadow-[0_20px_60px_rgba(38,53,98,0.08)] sm:p-8">
              <BookingSearch />
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-0 py-10 sm:px-6 lg:px-10 lg:py-14">
          <div className="mb-6 px-6 sm:px-0">
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#3AB0E1]">
              Direct booking
            </p>
            <h2 className="mt-2 font-display text-3xl font-bold text-[#263562]">
              Book online
            </h2>
          </div>
          <BookingEngine />
        </section>
      </main>
      <Footer />
    </div>
  );
}
